import React, { Component } from 'react';
import {Map, GoogleApiWrapper, Circle, Marker, InfoWindow} from 'google-maps-react';
import {getSingleSell} from "../../../utility/serverUtility";
import { isSuccess} from "../../../utility/utility";
import Loader from "../../layouts/Loader";
import { LightgalleryProvider, LightgalleryItem } from "react-lightgallery";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs ,Pagination} from "swiper";
import Photo from "../../layouts/Photo";
import PhotoGallery from "../../layouts/PhotoGallery";

class Content extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            roomId: this.props.roomId,
            loading:true,
            thumbsSwiper:null,
            marker:null


        }
        this.lightGalleryRef = React.createRef(null);
        this.navigationPrevRef = React.createRef(null);
        this.navigationNextRef = React.createRef(null);
        this.paginationRef = React.createRef(null);
        //this.marker = React.createRef(null);

    }
    onMarkerClick = (props, marker, e) => {
        //console.log("props",props)

        //console.log("marker",marker)
        let markerComponent = marker;
        //console.log("markerCOmponent",markerComponent)
        this.setState({

            marker: markerComponent,

        });
    }
    async componentDidMount() {



        console.log("#### SING SELL ROOM ",this.state.roomId)
        this.setState({loading:false})

        const response = await getSingleSell(this.state.roomId)
        if (isSuccess(response)) {
            console.log("#### SEARCH ROOM ",response.data.risultato[0].nome)
                this.setState({
                    items: response.data.risultato,
                    loading:false
                })

            this.props.setName(response.data.risultato[0].nome,response.data.risultato[0].foto[0])



        }




    }

    openGallery(){
        //console.log(this.lightGalleryRef.current)
        //this.lightGalleryRef.current.openGalleryByIndex(0,"group2")
        //this.lightGalleryRef.current.openGallery("group2")
        this.lightGalleryRef.current.openGalleryByIndex(0,"group2")

    }



    render() {
        const { items} = this.state;

        const renderitem = items.map((item, i) => {
            return  <div style={{marginRight: "0px",marginLeft: "0px"}} className="row">
                {/* details */}
                <div className="col-lg-12">
                    <div className="deatils-box">
                        <div className="thumb-v2">
                            <LightgalleryProvider ref={this.lightGalleryRef}  >
                                <Swiper
                                    autoplay = {{
                                        delay: 2800,
                                    }}
                                    spaceBetween={10}
                                    navigation={true}
                                    pagination={{
                                        clickable: true,
                                        el: ".swiper-pagination",
                                        type: "fraction",
                                    }}
                                    thumbs={{ swiper: this.state.thumbsSwiper }}
                                    modules={[ Navigation, Thumbs,Pagination]}
                                    className="mySwiper2"
                                    navigation={{
                                        prevEl: this.navigationPrevRef.current,
                                        nextEl: this.navigationNextRef.current,
                                    }}
                                >
                                    <div className="swiper-action">
                                        <div style={{marginRight: "1.5rem",cursor:"pointer"}}  >
                                            <svg onClick={e => this.openGallery()} className="me-4" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2.99217 1.9882C2.84446 1.98733 2.69838 2.01921 2.56445 2.08151C2.43051 2.14381 2.31204 2.23498 2.21755 2.34853C2.12306 2.46207 2.05489 2.59513 2.01795 2.73815C1.98101 2.88118 1.97621 3.03066 2.00389 3.17576V7.00189C1.99147 7.1402 2.008 7.27954 2.05242 7.41112C2.09683 7.5427 2.16816 7.66365 2.26187 7.76614C2.35557 7.86864 2.4696 7.95051 2.59668 8.00651C2.72376 8.06252 2.86111 8.09141 2.99999 8.09141C3.13886 8.09141 3.27621 8.06252 3.40329 8.00651C3.53037 7.95051 3.6444 7.86864 3.7381 7.76614C3.83181 7.66365 3.90314 7.5427 3.94756 7.41112C3.99197 7.27954 4.0085 7.1402 3.99608 7.00189V5.41397L9.28905 10.7069C9.4772 10.8944 9.73205 10.9995 9.99765 10.9993C10.2632 10.999 10.5179 10.8934 10.7057 10.7056C10.8935 10.5178 10.9991 10.2631 10.9994 9.99755C10.9996 9.73195 10.8945 9.47716 10.707 9.289L5.41405 3.99596H7.00194C7.13511 3.99887 7.26751 3.97523 7.39139 3.92629C7.51527 3.87735 7.62813 3.8041 7.72334 3.71095C7.81855 3.6178 7.8942 3.50662 7.94585 3.38384C7.99749 3.26106 8.0241 3.12926 8.0241 2.99606C8.0241 2.86286 7.99749 2.73094 7.94585 2.60816C7.8942 2.48538 7.81855 2.3742 7.72334 2.28105C7.62813 2.1879 7.51527 2.11465 7.39139 2.06571C7.26751 2.01676 7.13511 1.99312 7.00194 1.99604H3.10155C3.06526 1.99152 3.02874 1.98895 2.99217 1.98843L2.99217 1.9882ZM20.9824 1.9882C20.9556 1.98964 20.9289 1.9921 20.9023 1.9957H17.0039C16.8707 1.99278 16.7383 2.01653 16.6144 2.06548C16.4906 2.11442 16.3777 2.18756 16.2825 2.28071C16.1873 2.37385 16.1116 2.48515 16.06 2.60793C16.0083 2.73071 15.9817 2.86251 15.9817 2.99571C15.9817 3.12891 16.0083 3.26083 16.06 3.38361C16.1116 3.50638 16.1873 3.61757 16.2825 3.71072C16.3777 3.80386 16.4906 3.87712 16.6144 3.92606C16.7383 3.975 16.8707 3.99864 17.0039 3.99573H18.5879L13.291 9.28866C13.1096 9.47779 13.0096 9.73045 13.0122 9.99247C13.0149 10.2545 13.1201 10.5051 13.3052 10.6905C13.4904 10.8759 13.7408 10.9815 14.0028 10.9845C14.2648 10.9875 14.5176 10.8878 14.707 10.7067L20 5.41351V7.00142C20 7.2669 20.1054 7.52144 20.2932 7.70916C20.4809 7.89688 20.7355 8.00236 21.001 8.00236C21.2664 8.00236 21.521 7.89688 21.7088 7.70916C21.8965 7.52144 22.0019 7.2669 22.0019 7.00142V3.12051C22.0212 2.97683 22.0091 2.83076 21.9663 2.69225C21.9235 2.55374 21.8511 2.42618 21.7541 2.31842C21.6571 2.21067 21.5379 2.12523 21.4046 2.06813C21.2714 2.01103 21.1273 1.98363 20.9824 1.98774V1.9882ZM9.98241 12.9881C9.72056 12.9944 9.47161 13.1031 9.28905 13.2909L3.99608 18.5897V15.9999C3.99865 15.8576 3.97078 15.7162 3.91433 15.5854C3.85788 15.4547 3.77415 15.3375 3.66875 15.2417C3.56335 15.1459 3.43871 15.0738 3.30316 15.03C3.16762 14.9863 3.0243 14.972 2.8828 14.9882C2.63707 15.0181 2.41117 15.1382 2.24882 15.3251C2.08647 15.512 1.9992 15.7524 2.00389 15.9999V20.7968C1.96537 20.9613 1.96913 21.1329 2.01484 21.2955C2.06055 21.4582 2.14671 21.6065 2.26529 21.7268C2.38386 21.8471 2.53099 21.9355 2.69293 21.9835C2.85487 22.0316 3.02636 22.038 3.19139 22.0019H7.99803C8.1312 22.0048 8.26361 21.981 8.38749 21.9321C8.51137 21.8832 8.62422 21.81 8.71944 21.7169C8.81465 21.6237 8.8903 21.5124 8.94194 21.3897C8.99359 21.2669 9.02019 21.1351 9.02019 21.0019C9.02019 20.8687 8.99359 20.7369 8.94194 20.6141C8.8903 20.4913 8.81465 20.38 8.71944 20.2869C8.62422 20.1937 8.51137 20.1206 8.38749 20.0716C8.26361 20.0227 8.1312 19.9989 7.99803 20.0019H5.41405L10.707 14.7089C10.8528 14.5688 10.9527 14.3878 10.9935 14.1898C11.0344 13.9917 11.0142 13.786 10.9358 13.5997C10.8573 13.4133 10.7242 13.2551 10.554 13.1459C10.3838 13.0368 10.1845 12.9817 9.98241 12.9881ZM13.9922 12.9881C13.7921 12.9866 13.5961 13.0452 13.4297 13.1562C13.2632 13.2672 13.1338 13.4256 13.0583 13.6109C12.9828 13.7962 12.9646 13.9999 13.0061 14.1957C13.0476 14.3914 13.1468 14.5702 13.291 14.7089L18.5879 20.0019H16C15.7386 20.0076 15.4898 20.1154 15.3069 20.3023C15.1241 20.4892 15.0217 20.7404 15.0217 21.0019C15.0217 21.2634 15.1241 21.5144 15.3069 21.7013C15.4898 21.8882 15.7386 21.9962 16 22.0019H20.7305C20.9071 22.0623 21.0971 22.0721 21.279 22.0301C21.4609 21.9882 21.6274 21.8961 21.7597 21.7644C21.892 21.6327 21.9849 21.4666 22.0277 21.2849C22.0705 21.1032 22.0616 20.9131 22.0019 20.7362V15.9999C22.0045 15.8574 21.9766 15.7159 21.9201 15.5849C21.8635 15.454 21.7796 15.3367 21.674 15.2409C21.5683 15.1451 21.4435 15.0729 21.3077 15.0293C21.1719 14.9858 21.0284 14.9717 20.8867 14.9882C20.6396 15.0163 20.4118 15.1356 20.2478 15.3227C20.0839 15.5097 19.9955 15.7512 20 15.9999V18.5897L14.707 13.2909C14.6141 13.1953 14.5029 13.1194 14.3802 13.0674C14.2574 13.0154 14.1255 12.9884 13.9922 12.9881Z" fill="white"/>
                                            </svg>
                                        </div>
                                        {item.foto.length>1 && <div className="swiper-control-area">
                                            <div className="swiper-button-prev" ref={this.navigationPrevRef}></div>
                                            <div className="swiper-pagination swiper-pagination-fraction swiper-pagination-horizontal" ref={this.paginationRef}>
                                                <span className="swiper-pagination-current">1</span> / <span className="swiper-pagination-total">6</span>
                                            </div>
                                            <div className="swiper-button-next" ref={this.navigationNextRef}></div>
                                        </div>}
                                    </div>
                                {item.foto.length>0 && item.foto.map((singleFoto,index)=>(
                                    <div>
                                        <SwiperSlide>
                                            <LightgalleryItem group="group2" src={singleFoto} >
                                                {/*<button className="expand-button" id={"button-img-"+index}>
                                                    <i className="fa fa-expand"></i>
                                                </button>*/}
                                            </LightgalleryItem>
                                            <div className="room-details-wrap">
                                                {/*<img src={singleFoto} className="w-100"/>*/}
                                                <Photo foto={singleFoto}/>
                                            </div>

                                        </SwiperSlide>
                                    </div>
                                ))}
                                    {item.foto.length==0 &&  <Photo foto={process.env.PUBLIC_URL + "/assets/img/image-utility/room-details-image-empty.jpg"}/>}
                                </Swiper>
                            </LightgalleryProvider>
                            <Swiper
                                onSwiper={(event) => this.setState({ thumbsSwiper: event })}
                                spaceBetween={10}
                                slidesPerView={4}
                                freeMode={true}
                                autoplay = {{
                                    delay: 2400,
                                }}
                                watchSlidesProgress={true}
                                modules={[FreeMode, Navigation, Thumbs]}
                                className="mySwiper"
                            >
                                {item.foto.length>0 && item.foto.map((singleFoto,index)=>(
                                    <div>
                                     <SwiperSlide>
                                         <div className="swiper-img">
                                             {/*<img src={singleFoto}  />*/}
                                             <PhotoGallery foto={singleFoto}/>
                                         </div>
                                    </SwiperSlide>

                                    </div>
                                    ))}
                                {item.foto.length==0 &&  <PhotoGallery foto={process.env.PUBLIC_URL + "/assets/img/image-utility/room-details-image-empty.jpg"}/>}
                            </Swiper>
                        </div>


                        {/* ########### DESCRIZIONE #######*/}

                        <div dangerouslySetInnerHTML={{__html:  item.descrizione !=undefined && item.descrizione}}/>


                        {/* ########### MAP #######*/}
                        {item.locazione != undefined && item.locazione.lat!=undefined && item.locazione.long!=undefined &&
                            <div style={{marginTop: "60px"}} className="room-map mb-60 position-relative" id="roomMap">
                                <Map
                                    onReady={this.onMarkerClick}
                                    google={this.props.google}
                                    zoom={14}
                                    initialCenter={{
                                        "lat": item.locazione != undefined && item.locazione.lat,
                                        "lng": item.locazione != undefined && item.locazione.long
                                    }}
                                >
                                    {/*<Circle
                                        center={{lat: item.locazione.lat, lng: item.locazione.long}}
                                        radius={600}
                                        fillOpacity={0.20}
                                        strokeColor='#84D1FF'
                                        strokeOpacity={1}
                                        strokeWeight={2}
                                    />*/}
                                    <Marker
                                        onClick={this.onMarkerClick}
                                        title={item.nome!=undefined && item.nome}
                                        name={item.nome!=undefined && item.nome}
                                        position={{lat: item.locazione.lat, lng: item.locazione.long}}
                                        >

                                    </Marker>
                                    <InfoWindow
                                        marker={this.state.marker}
                                        visible={true}>
                                        <div>
                                            {item.nome!=undefined && item.nome}
                                        </div>
                                    </InfoWindow>
                                </Map>
                            </div>
                        }
                    </div>
                </div>
            </div>

        });

        return (
            <section className="room-details pt-120 pb-90">
                <div className="container">

                    {this.state.items.length != 0 ? renderitem : <Loader />}
                </div>
            </section>
        );
    }
}

export default GoogleApiWrapper({
    apiKey: 'AIzaSyBCB4y0SztfLo236n4JECwTvIQd-VecF2Y',
})(Content);